<template>
	<b-container fluid class="dashboard">
		<b-row class="dashContent">
			<b-col md="3">
				<div class="userProfile">
					<img src="/public/images/anonymous.jpg" class="avatar">
					<h5 class="greetings">Sugeng Rawuh,</h5>
					<h4>Kang Mimin</h4>
					<!-- <b-button to="/profile" pill variant="outline-secondary" size="sm">View Profile</b-button> -->
				</div>
				<div class="menuBar">
					<b-nav vertical class="">
						<!-- <b-nav-item to="/list">Dashboard</b-nav-item> -->
						<b-nav-item to="/list">Participant List</b-nav-item>
						<b-nav-item to="/maileditor">E-mail Editor</b-nav-item>
					</b-nav>
					<b-nav vertical class="mt-2" v-for="(content, index) in contents" v-bind:data="content" v-bind:key="index">
						<b-nav-item @click="selected(content)">{{content.subject}}</b-nav-item>
					</b-nav>
					<!-- <b-nav-form class="mt-2">
						<b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
						<b-button size="sm" class="my-2 my-sm-0" type="submit"><b-icon icon="search"></b-icon></b-button>
					</b-nav-form> -->
				</div>
			</b-col>
			<b-col md="9">
				<div class="clearfix mailEditor">
					<b-form-input v-model="target.key" placeholder="Authentication Key"></b-form-input>
					<b-form-input v-model="target.email" placeholder="Target E-mail address"></b-form-input>
					<b-form-input v-model="target.subject" placeholder="Subject"></b-form-input>
					<b-form-select v-model="target.template" :options="templates" class="mb-4"></b-form-select>
					<div class="quill-editor" 
						v-model="target.content"
						v-quill:myQuillEditor="editorOption">
					</div>
					<hr/>
					<div>{{status}}</div>
				</div>
				<b-button variant="primary" @click="send">Send</b-button>
				<b-button variant="warning" @click="save">Save</b-button>
				<!-- <b-button variant="primary" @click="send">Send</b-button> -->
			</b-col>		
		</b-row>
	</b-container>
</template>
<style lang="stylus">
	.mailEditor {background: white; padding: 10px;}
</style>
<script>
	export default {
		data() {
			return {
				status : 'Ready',
				target : {
					key: null,
					email: null,
					template: null,
					content: null,
					subject: null,
				},
				signedin : true,
				data: null,
				editorOption: {},
				templates: [
					{ value: null, text: 'Select Template' },
					{ value: 'multi_purpose', text: 'Multi Purpose' },
				],
				contents : []
			}
		},
		components : {
		},
		methods: {
			selected(data){
				this.target = data;
				if (this.$route.query.mbsdEmail){
					this.target.email = this.$route.query.mbsdEmail;
				}
			},
			save(){
				this.contents.push(this.target);
				if (localStorage){
					localStorage.setItem('contents', JSON.stringify(this.contents))
				}			
			},
			send(){
				this.status = 'Sending...';
				this.$store.dispatch('SENDMAIL',{
					key : this.target.key,
					data : {
						"from": "Borobudur Marathon <info@borobudurmarathon.com>",
						"target": this.target.email,
						"template": this.target.template,
						"language": "en",
						"data": {
							"html": this.target.content,
							"subject": this.target.subject
						}						
					}
				}).then(sent=>{
					console.log(sent);
					this.status = 'Sent... ID : ' + sent.data.queueId;	
				})
			}
		},
		mounted(){
			if (localStorage&&localStorage.getItem('contents')){
				this.contents = JSON.parse(localStorage.getItem('contents'));
			}
			if (this.$route.query.mbsdEmail){
				this.target.email = this.$route.query.mbsdEmail;
			}
			this.$store.commit('ACTIVATE_ADMIN');
			this.$store.dispatch('CHECK')
				.then((checkOut) =>{
					console.log(checkOut);
					this.data = checkOut.data;
				})
				.catch(err => {
					console.log(err);
				})
		},
	}
</script>


// WEBPACK FOOTER //
// MailEditor.vue